import classNames from 'classnames/bind';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';
import Select from '@/components/ui/kit/Select';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const [direction, setDirection] = useState();
  const [offset, setOffset] = useState();
  const domRefs = useRef({
    heading: useRef(),
    rate: useRef(),
  }).current;

  useEffect(() => {
    setDirection(command.data.direction);
    setOffset(command.data.offset);
    domRefs.heading.current.value = command.data.heading.toFixed(1);
    domRefs.rate.current.value = command.data.rate.toFixed(1);
  }, [command.data]);

  const handleBlur = (e) => {
    const name = e.target.name;
    let value = Number(e.target.value);

    // https://mavlink.io/en/messages/common.html#MAV_CMD_CONDITION_YAW
    switch (name) {
      case 'heading':
        value = Math.max(0, Math.min(360, value));
        break;
      case 'rate':
        value = Math.max(0, value);
        break;
      default:
        break;
    }

    dispatch(actions.mission.updateCommand(index, name, value));
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Direction">
        <Select name="direction" value={direction} onChange={handleBlur} className={cx('select')}>
          <option value={1}>Clockwise</option>
          <option value={0}>Shortest</option>
          <option value={-1}>Counter-Clockwise</option>
        </Select>
      </FieldRow>
      <FieldRow label="Offset">
        <Select name="offset" value={offset} onChange={handleBlur} className={cx('select')}>
          <option value={1}>Relative</option>
          <option value={0}>Absolute</option>
        </Select>
      </FieldRow>
      <FieldRow label="Heading" unit="deg">
        <FieldNumber ref={domRefs.heading} name="heading" onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Rate" unit="deg/s">
        <FieldNumber ref={domRefs.rate} name="rate" onBlur={handleBlur} />
      </FieldRow>
    </div>
  );
};

export default Command;
